import { useLocation, useNavigate, useParams } from "react-router";
import logo from "../../Assest/pink.png";
import avatar from "../../Assest/avtar.webp";
import { useEffect, useState } from "react";
import { useJwt } from "react-jwt";
import "../headerDasboard/header.css";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [roles, setRoles] = useState([]);
  const token = localStorage.getItem("token");
  const data = useJwt(token);
  const logoutHandler = () => {
    navigate("/");
  };

  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = () => setIsOpen(!isOpen);

  const [selectedValue, setSelectedValue] = useState();
  const ChangesHandler = (e) => {
    setSelectedValue(e.target.value);
    navigate(`/admin/${e.target.value}`);
  }
  useEffect(()=>{
    const l = location.pathname.split('/');
    setSelectedValue(l[l.length-1]);
    const roleOptions = data?.decodedToken?.role || [];
    setRoles(roleOptions);
  },[data])

  return (
    <nav className="bg-dark py-2 position-relative">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <img src={logo} alt="Logo" height={50} />
        </div>

        <div className="form-group">
          <select className="form-select" value={selectedValue} onChange={ChangesHandler}>
            {roles?.map((item, index) => (
              <option key={index} value={item}>{item}</option>
            ))}
          </select>
        </div>

        <div className="position-relative">
          <img
            onClick={toggleDropdown}
            className="rounded-circle"
            aria-haspopup="true"
            aria-expanded={isOpen}
            width={50}
            height={50}
            src={avatar}
            alt="User Avatar"
            style={{ cursor: "pointer" }}
          />
          {isOpen && (
            <div
              className="dropdown-menu show text-center bg-white p-2"
              style={{
                position: "absolute",
                right: 0,
                top: "60px",
                zIndex: 1000,
              }}
            >
              <div className="">
                <div className="p-0">
                  <p className="m-0 p-0 text-capitalize text-start">
                    {data?.decodedToken?.name}
                  </p>
                  <p className="mb-3 p-0">{data?.decodedToken?.email}</p>
                </div>
                <button className="btn btn-dark w-100" onClick={logoutHandler}>
                  Logout
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Header;
